import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { CheckboxComponent } from '../checkbox/CheckboxComponent';
import { formatDate } from '../../../utility/dates';
import classNames from 'classnames';
import styles from '../../styles.module.scss';

export const OverviewRowComponent = ({ propKey, label, value, overviewPropertyType }) => {
  let valueComponent = <Fragment>{value}</Fragment>;

  if (overviewPropertyType === 'boolean') {
    valueComponent = <CheckboxComponent propKey={propKey} value={value} disabled="disabled" />;
  } else if (overviewPropertyType === 'date') {
    valueComponent = <Fragment>{formatDate(value)}</Fragment>;
  }

  return (
    <tr>
      <td className={classNames(styles.keyTd)}>{label}</td>
      <td className={classNames(styles.valueTd)}>{valueComponent}</td>
    </tr>
  );
};

OverviewRowComponent.propTypes = {
  propKey: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
  overviewPropertyType: PropTypes.string
};
